export type PassoType = 'condition' | 'default';

export enum TipoPasso {
  QUESTIONNARIE = 'questionnarie',
  CONDITION = 'condition',
  BREAKPOINT = 'breakpoint',
}
